import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIFile extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  postOrderId = async (
    orderId: UUID,
    { ...body }: types.BodyUploadOrderFileOrdersFileOrderIdPost,
  ): Promise<types.AttachedFile> => {
    let res = await this._fetch({
      url: `/orders/file/${orderId}`,
      method: "POST",
      body: body,
      bodyMime: "multipart/form-data",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getOrderId = async (
    orderId: UUID,
    { originalFilename }: { originalFilename: string },
  ): Promise<Response> => {
    let res = await this._fetch({
      url: `/orders/file/${orderId}`,
      method: "GET",
      params: { original_filename: originalFilename },
      auth: ["OAuth2PasswordBearer"],
    });
    return res;
  };
}
